<span #contentWrapper class="icon-text-wrapper" [title]="title">
  <img
    *ngIf="iconSrc || forceIcon"
    [src]="iconSrc"
    default="/assets/img/default-product-icon.svg"
    [ngStyle]="{ maxWidth: iconWidth }"
  />
  <ng-content></ng-content>
</span>
